import { useState, useCallback, useRef } from 'react';
import { fetch } from '../../../utils/api-wrapper';
import { prepareStatementsForDisplay } from '../utils';

export function useStatementData({ t, setAccountMasks = () => {}, toast = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [statements, setStatements] = useState([]);
  const [error, setError] = useState(null);
  const [years, setYears] = useState([]);
  const hasSetYears = useRef(false);

  const getYearsFromStatements = (statements) => {
    const yearsSet = new Set();
    statements.forEach((statement) => {
      if (statement.year) {
        yearsSet.add(statement.year);
      }
    });
    return Array.from(yearsSet).sort((a, b) => b - a);
  };

  const fetchStatements = useCallback(
    async ({ start = 0, pageSize = 25, sorting = [], filters = [], globalfilter = '', hideCompletedStatements = false } = {}) => {
      const query = new URLSearchParams({
        start,
        page_size: pageSize,
        sorting: JSON.stringify(sorting),
        filters: JSON.stringify(filters),
        globalfilter,
      }).toString();

      return await new Promise((resolve) => {
        fetch(
          `/c_card/statements/?${query}`,
          'GET',
          {},
          (response) => {
            setStatements(prepareStatementsForDisplay(response.data.statements, t, hideCompletedStatements));
            setAccountMasks(response.data.account_masks || []);
            if (!hasSetYears.current) {
              setYears(getYearsFromStatements(response.data.statements));
              hasSetYears.current = true;
            }
            setLoading(false);
            resolve(true);
            return true;
          },
          (err) => {
            console.error('Failed to fetch statements', err);
            setError(t.read('cc_statements.error_fetching_statements'));
            resolve(false);
            return false;
          }
        );
      });
    },
    [t]
  );

  const generateStatements = useCallback((card_ids) => {
    if (!Array.isArray(card_ids) || card_ids.length === 0) {
      toast.error(t.read('cc_statements.no_cards_selected'));
      return;
    }
    setLoading(true);
    fetch(
      `/plaid/statements/generate`,
      'POST',
      { card_ids },
      (response) => {
        toast.success(t.read('cc_statements.statements_generated'));
        setLoading(false);
      },
      (err) => {
        console.error('Failed to generate statements', err);
        toast.error(t.read('cc_statements.error_generating_statements'));
        setLoading(false);
      }
    );
  }, [t, toast]);

  return {
    statements,
    setStatements,
    loading,
    setLoading,
    error,
    fetchStatements,
    generateStatements,
    years,
  };
}
